import { render, staticRenderFns } from "./VeicoliCard.vue?vue&type=template&id=1a8bf419&scoped=true"
import script from "./VeicoliCard.vue?vue&type=script&lang=ts"
export * from "./VeicoliCard.vue?vue&type=script&lang=ts"
import style0 from "./VeicoliCard.vue?vue&type=style&index=0&id=1a8bf419&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8bf419",
  null
  
)

export default component.exports